import { setUploadOrderAction } from 'editor/src/store/gallery/slice';
import { ImageState } from 'editor/src/store/gallery/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

interface UploadBatchFile {
  id: string;
  name?: string;
  // set on a folder drop, e.g. "ch2/page-01.pdf", so same-named pages of different folders stay apart
  relativePath?: string | null;
}

// "page-2" before "page-10"
const fileNameCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

// A multi-file selection or drop does not reliably arrive in page order, and its uploads report back in
// whatever order they finish; ordering the batch by file name is what keeps numbered pages in sequence.
const orderUploadBatchOperation =
  (files: UploadBatchFile[]) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const { images } = getState().gallery;
    // A retry re-uploads failed files, which keep their place in the gallery.
    const failedUploaderIds = new Set(
      images.filter((image) => image.state === ImageState.FAILED).map((image) => image.uploaderId),
    );
    const newFiles = files.filter((file) => !failedUploaderIds.has(file.id));
    if (!newFiles.length) {
      return;
    }

    const uploadOrder = [...newFiles]
      .sort((a, b) => fileNameCollator.compare(a.relativePath ?? a.name ?? '', b.relativePath ?? b.name ?? ''))
      .map((file) => file.id);
    dispatch(setUploadOrderAction(uploadOrder));
  };

export default orderUploadBatchOperation;
